<template>
  <BaseMarquee
    :items="blok.members"
    :animation-time="blok.animation_time"
    :slide-width="'270'"
    :slides-count="membersCount"
    :gradient-color="blok.gradient_color.value"
  >
    <template #default>
      <div
        v-for="(member, i) in doubledMembers"
        :key="member.uuid + i"
        class="marquee__slide"
      >
        <BaseCard
          class="marquee-card"
          shadow="shadow-grey-small"
          :border-radius="20"
          :padding="{ mobile: '24', tablet: '24', desktop: '24' }"
        >
          <BaseNuxtImage
            :src="imgSrc(member)"
            :alt="imgAlt(member)"
            loading="lazy"
            class="marquee-card__image"
          />
          <p class="marquee-card__name">
            {{ member.content.name }}
          </p>
          <p class="marquee-card__role">
            {{ member.content.role }}
          </p>
        </BaseCard>
      </div>
    </template>
  </BaseMarquee>
</template>
<script lang="ts" setup>
import type { BlogAuthor, SbInfiniteMarquee } from '@/types'

interface Props {
  blok: SbInfiniteMarquee
}
type BlogAuthorContent = {
  content: BlogAuthor
}
const props = defineProps<Props>()
const doubledMembers = computed(() => {
  return [...props.blok.members, ...props.blok.members]
})

const membersCount = computed(() => {
  return props.blok.members.length
})

const imgSrc = (member: BlogAuthorContent) => {
  return member.content.photo?.filename
}
const imgAlt = (member: BlogAuthorContent) => {
  return member.content.photo?.alt || 'author image'
}
</script>

<style scoped lang="scss">
.marquee-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  &__image {
    width: 128px;
    height: 128px;
    margin-bottom: 16px;
  }

  &__role {
    @include paragraph-s;

    margin: 0;
  }

  &__name {
    @include paragraph-m;

    margin: 0;
    font-weight: var(--font-weight-semibold);
  }
}
</style>
